import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityAuditLog = () => {
  // Mock data - replace with real audit log from Supabase
  const auditLogs = [
    {
      id: 1,
      action: 'User Login',
      user: 'admin@sailorsbailbonds.com',
      timestamp: new Date(Date.now() - 1000 * 60 * 5), // 5 minutes ago
      status: 'success',
      ip: '192.168.1.1'
    },
    {
      id: 2,
      action: 'Password Changed',
      user: 'agent@sailorsbailbonds.com',
      timestamp: new Date(Date.now() - 1000 * 60 * 30), // 30 minutes ago
      status: 'success',
      ip: '192.168.1.2'
    },
    {
      id: 3,
      action: 'Failed Login Attempt',
      user: 'unknown@example.com',
      timestamp: new Date(Date.now() - 1000 * 60 * 60), // 1 hour ago
      status: 'failed',
      ip: '192.168.1.3'
    }
  ];

  const formatTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);
    
    if (seconds < 60) return 'Just now';
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    return `${Math.floor(seconds / 86400)}d ago`;
  };

  const getActionIcon = (action) => {
    if (action?.includes('Login')) return 'LogIn';
    if (action?.includes('Password')) return 'Key';
    if (action?.includes('Created')) return 'UserPlus';
    if (action?.includes('Deleted')) return 'UserMinus';
    return 'Activity';
  };

  const getStatusColor = (status) => {
    return status === 'success' ? 'text-accent' : 'text-error';
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-soft overflow-hidden">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-foreground">Security Audit Log</h3>
          <Icon name="Shield" size={16} color="var(--color-primary)" />
        </div>
      </div>

      <div className="divide-y divide-border">
        {auditLogs?.map((log) => (
          <div key={log?.id} className="p-4 hover:bg-muted/20 transition-colors">
            <div className="flex items-start space-x-3">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                log?.status === 'success' ? 'bg-accent/10' : 'bg-error/10'
              }`}>
                <Icon 
                  name={getActionIcon(log?.action)} 
                  size={14} 
                  color={log?.status === 'success' ? 'var(--color-accent)' : 'var(--color-error)'}
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <p className="text-xs font-medium text-foreground truncate">
                    {log?.action}
                  </p>
                  <span className="text-xs text-muted-foreground whitespace-nowrap ml-2">
                    {formatTimeAgo(log?.timestamp)}
                  </span>
                </div>
                
                <p className="text-xs text-muted-foreground truncate mt-1">
                  {log?.user}
                </p>
                
                <div className="flex items-center space-x-2 mt-1">
                  <span className={`text-xs ${getStatusColor(log?.status)}`}>
                    {log?.status}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    • {log?.ip}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="p-3 border-t border-border bg-muted/30">
        <button className="w-full text-xs text-primary hover:text-primary/80 font-medium transition-colors">
          View Full Audit Log
        </button>
      </div>
    </div>
  );
};

export default SecurityAuditLog;